module.exports = __webpack_public_path__ + "img/whatsapp.d78b606a.svg";